import { shallowMount } from "@vue/test-utils";
import PdfViewer from "@/components/core/custom/PdfViewer";

jest.mock("vue-pdf-embed/dist/vue2-pdf-embed", () => ({
  __esModule: true,
  default: {
    name: "VuePdfEmbed",
    render: fn => fn("div")
  }
}));

describe("PdfViewer component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(PdfViewer, {
      propsData: {
        src: "https://"
      }
    });
  });

  it("Renders del component PdfViewer", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
